import apiClient from '@/services/AccountClient'

export default {
  sendFreetextNotification (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/notifications/freetext',
      data
    )
  }
}
